export enum RecrutementTypeEnum {
  sans_publication = 1,
  interne = 2,
  externe = 3,
  interne_externe = 4
}
